import * as v from 'valibot';
import { IdSchema, TimestampSchema } from './common.js';
export const GroupSchema = v.object({
    id: IdSchema,
    roomId: v.nullable(IdSchema),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    createdAt: TimestampSchema
});
/** API list/detail shape: rooms this group can access via permissions. */
export const GroupWithRoomAccessSchema = v.object({
    ...GroupSchema.entries,
    roomIds: v.array(IdSchema)
});
export const GroupMembershipSchema = v.object({
    groupId: IdSchema,
    userId: IdSchema
});
export const CreateGroupSchema = v.object({
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    roomId: v.optional(IdSchema)
});
export const UpdateGroupSchema = v.object({
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255))
});
export const AddGroupMemberBodySchema = v.object({
    userId: IdSchema
});
export const AddUserToGroupSchema = v.object({
    groupId: IdSchema,
    userId: IdSchema
});
//# sourceMappingURL=group.js.map